import React from 'react';
import { RevshareOrder } from '../../../../api/client/clientRevshareService';
import IdView from '../../../../components/id-view';

interface IdCellProps {
  campaign: RevshareOrder;
}

const IdCell: React.FC<IdCellProps> = ({ campaign }) => {
  return <IdView textToCopy={campaign._id}>{campaign._id.slice(-4)}</IdView>;
};

export default IdCell;
